import {
    type GetAllProfileUpdateRequestHistoriesResponseType,
    type GetAllProfileUpdateRequestHistoriesRequestType
} from "./type";
import {
    request
} from "../request";

const getAllProfileUpdateRequestHistories = async (
    params: GetAllProfileUpdateRequestHistoriesRequestType
): Promise<GetAllProfileUpdateRequestHistoriesResponseType> => {
    const searchParams = new URLSearchParams();

    if(params.search) {
        searchParams.append("search", params.search);
    }

    if(params.reason) {
        searchParams.append("reason", params.reason);
    }

    if(params.page !== undefined) {
        searchParams.append("page", String(params.page));
    }

    const queryStr = searchParams.toString();
    const endpoint = queryStr ? `/request/getAllProfileUpdateRequestHistories?${queryStr}` : "/request/getAllProfileUpdateRequestHistories";

    return await request<GetAllProfileUpdateRequestHistoriesResponseType>(endpoint, {
        method: "GET"
    });
};
export default getAllProfileUpdateRequestHistories;
